import { IAuditLog } from '../../../types';

import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: Array<IAuditLog> = [];

const slice = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {
    getAuditLog: (
      _state,
      _action: PayloadAction<{
        studentNo: string;
        uni: string;
        intakeId: string;
        offerId: string;
      }>,
    ) => {},
    getAuditLogSuccess: (_state, action: PayloadAction<{ auditlogs?: IAuditLog[] }>) => {
      const auditLog = action.payload?.auditlogs ?? [];
      return auditLog;
    },
    getAuditLogFailure: (_state, _action: AnyAction) => {
      return [];
    },
  },
});

export const { getAuditLog, getAuditLogSuccess, getAuditLogFailure } = slice.actions;
export const AuditLogReducer = slice.reducer;
